const activitycategory = {
  getlist: 'activitycategory/getlist',
  add: 'activitycategory/add',
  update: 'activitycategory/update',
  remove: 'activitycategory/remove',
  get: 'activitycategory/get',
  getall: 'activitycategory/getall',
  clearcache: 'activitycategory/clear-cache',
}
export default activitycategory
